import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PortalProductsService } from '../../../../app/services/portal-products.service';
import { AccountService } from '../../../services/account.service';
import { DOCUMENT } from '@angular/common';

export interface Product {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
  isAvailable: boolean;
  features: string[];
  requirements: string[];
  status?: string;
  statusPending?: boolean;
}

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
})
export class ProductsComponent implements OnInit {
  toggle;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private portalProductsService: PortalProductsService,
    private accountService: AccountService
  ) {
    if (window.innerWidth < 769) {
      this.document.body.classList.add('sidebar-collapse-in');
      this.accountService.emit(true);
    }
    console.log('ProductSignupComponent: Constructor called');
    this.accountService.emitChange.subscribe((status) => (this.toggle = status));
  }

  async ngOnInit(): Promise<void> {}
  toggleMenu(event: any) {
    this.toggle = event;
  }
}
